module.exports = __webpack_public_path__ + "img/741-5e13db.png";